
<template>
  <zj-layout-container v-loading="loading" :element-loading-text="loadingText">
    <zj-layout-header>
      <div class="listtitle">物资详情</div>
    </zj-layout-header>
    <zj-layout-main>
      <div class="zj-layout-main-content bgcolor scrollable">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="16rem">
          <el-form-item label="物资装备名称" prop="MaterialName" style="display:inline-block;">
            <el-input v-model="ruleForm.MaterialName" style="width:40rem;" v-bind:disabled="IsEdit"></el-input>
          </el-form-item>
          <el-form-item label="物资装备编号" prop="MaterialCode" style="display:inline-block;">
            <el-input v-model="ruleForm.MaterialCode" style="width:40rem;" v-bind:disabled="IsEdit"></el-input>
          </el-form-item>
          <el-form-item label="物资装备类型" prop="MaterialTypeId" style="display:inline-block;">
            <el-select
              v-model="ruleForm.MaterialTypeId"
              style="width:40rem;"
              placeholder="请选择物资装备类型"
              v-bind:disabled="IsEdit"
            >
              <el-option
                v-for="item in options"
                :key="item.ItemKey"
                :label="item.Extend1"
                :value="item.ItemKey"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="物资装备类型子类" prop="SubTypeId" style="display:inline-block;">
            <el-select
              v-model="ruleForm.SubTypeId"
              style="width:40rem;"
              placeholder="请选择物资装备类型子类"
              v-bind:disabled="IsEdit"
            >
              <el-option
                v-for="item in optionsnext"
                :key="item.ItemKey"
                :label="item.Extend1"
                :value="item.ItemKey"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="库存数量" prop="StockNum" style="display:inline-block;">
            <el-input-number
              v-model="ruleForm.StockNum"
              style="width:40rem;"
              v-bind:disabled="IsEdit"
              :min="1"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="计量单位" prop="Unit" style="display:inline-block;">
            <el-input v-model="ruleForm.Unit" style="width:40rem;" v-bind:disabled="IsEdit"></el-input>
          </el-form-item>
          <el-form-item label="购入日期" prop="BuyDate" style="display:inline-block;">
            <el-date-picker
              type="date"
              placeholder="选择日期"
              v-model="ruleForm.BuyDate"
              style="width:40rem;"
              v-bind:disabled="IsEdit"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="有效日期" prop="ExpireDate" style="display:inline-block;">
            <el-date-picker
              placeholder="选择日期"
              v-model="ruleForm.ExpireDate"
              style="width:40rem;"
              v-bind:disabled="IsEdit"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="生产厂家" prop="ProduceCompany" style="display:inline-block;">
            <el-input
              v-model="ruleForm.ProduceCompany"
              style="width:40rem;"
              v-bind:disabled="IsEdit"
            ></el-input>
          </el-form-item>
          <el-form-item label="负责保管人" prop="Contact" style="display:inline-block;">
            <el-input v-model="ruleForm.Contact" style="width:40rem;" v-bind:disabled="IsEdit"></el-input>
          </el-form-item>
          <el-form-item label="移动电话" prop="Phone" style="display:inline-block;">
            <el-input v-model="ruleForm.Phone" style="width:40rem;" v-bind:disabled="IsEdit"></el-input>
          </el-form-item>
          <el-form-item label="物资所属企业" prop="CompanyName" style="display:inline-block;">
            <el-input v-model="ruleForm.CompanyName" style="width:40rem;" v-bind:disabled="IsEdit"></el-input>
          </el-form-item>
          <el-form-item label="存放仓库" prop="WarehouseId" style="display:inline-block;">
            <el-select
              v-model="ruleForm.WarehouseId"
              style="width:40rem;"
              placeholder="请选择存放仓库"
              v-bind:disabled="IsEdit"
              @change="changeWarehouse"
            >
              <el-option
                v-for="item in warehouselist"
                :key="item.WarehouseId"
                :label="item.WarehouseName"
                :value="item.WarehouseId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="存放地址" prop="Address" style="display:inline-block;">
            <el-input v-model="ruleForm.Address" style="width:40rem;" v-bind:disabled="IsEdit"></el-input>
          </el-form-item>
          <!-- <el-row :gutter="100">
          <el-col :span="12">
            <el-form-item label="经纬度" prop="Latitude">
              <el-input v-model="ruleForm.Latitude"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="100">
          <el-col :span="24">
            <el-form-item label="备注" prop="desc">
              <el-input type="textarea" v-model="ruleForm.desc"></el-input>
            </el-form-item>
          </el-col>
          </el-row>-->
        </el-form>
      </div>
    </zj-layout-main>
    <zj-layout-footer>
      <div style="width:116rem; text-align:center;margin:1rem 1rem;">
        <el-button @click="onBack()">返回</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')" v-show="IsEdit==false">保存</el-button>
        <el-button @click="resetForm()" v-show="IsEdit==false">重置</el-button>
      </div>
    </zj-layout-footer>
  </zj-layout-container>
</template>
<script>
import ZJApp from "../../../../../app";
import MyApis from "../../../apis";
const utils = ZJApp.ZJUtils;
export default {
  name: "ZjMaterialinfo",
  controller: "UI",
  action: "Materialinfo",
  props: {
    query: {
      type: String,
      obj: String
    }
  },
  data() {
    return {
      loading: true,
      loadingText: "加载中",
      ruleForm: {
        OrgId: "",
        MaterialName: "",
        MaterialCode: "",
        MaterialTypeId: null,
        SubTypeId: null,
        StockNum: 1,
        Unit: "",
        BuyDate: "",
        ExpireDate: "",
        ProduceCompany: "",
        Contact: "",
        Phone: "",
        CompanyName: "",
        WarehouseId: null,
        Address: "",
        IsInOut: true,
        Recipients: ""
        /* 
        Latitude: "",
        desc: "" */
      },
      options: [],
      optionsnext: [],
      warehouselist: [],
      rules: {
        MaterialName: [
          { required: true, message: "请输入物资装备名称", trigger: "blur" }
        ],
        MaterialTypeId: [
          { required: true, message: "请选择物资装备类型", trigger: "change" }
        ],
        SubTypeId: [
          {
            required: true,
            message: "请选择物资装备类型子类",
            trigger: "change"
          }
        ],
        BuyDate: [
          {
            //type: "date",
            required: true,
            message: "请选择日期",
            trigger: "change"
          }
        ],
        ExpireDate: [
          { required: true, message: "请选择时间", trigger: "change" }
        ],
        WarehouseId: [
          { required: true, message: "请选择存放仓库", trigger: "change" }
        ],
        Address:[
          { required: true, message: "请输入存放地址", trigger: "blur" }
        ],
        IsEdit: false
        //desc: [{ required: true, message: "请填写备注", trigger: "blur" }]
      }
    };
  },
  created: function() {
    this.basedatabind();
    this.search();
    this.IsEdit = this.query.type == "edit" ? false : true;
  },
  mounted: function() {},
  watch: {
    query: {
      // eslint-disable-next-line no-unused-vars
      handler: function(val, oldVal) {
        this.ruleForm = {
          MaterialName: "",
          MaterialCode: "",
          MaterialTypeId: null,
          SubTypeId: null,
          StockNum: 0,
          Unit: "",
          BuyDate: "",
          ExpireDate: "",
          ProduceCompany: "",
          Contact: "",
          Phone: "",
          CompanyName: "",
          WarehouseId: null,
          Address: "",
          IsInOut: true,
          Recipients: ""
        };
        this.search();
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    // 弹出一个错误消息
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox"
      });
    },
    //基础数据绑定
    basedatabind() {
      let searchInfo = {
        PageSize: 2000,
        PageIndex: 1,
        TotalCount: 0,
        StartNumber: 0,
        EndNumber: 0
      };

      this.loading = true;
      this.loadingText = "加载中...";
      utils
        .waitAll([
          this.config.getUValue("EmergencyService:MaterialType:", ""),
          this.config.getUValue("EmergencyService:SubType:", ""),
          new MyApis.MaterialWareHouseApi().FindByConditions(searchInfo)
        ])
        .then(r => {
          //物资类型
          this.options = r[0].JValue;

          //物资子类型
          this.optionsnext = r[1].JValue;

          // 存放仓库
          this.warehouselist = r[2].data.Data;

          this.loading = false;
        })
        .catch(e => {
          console.error(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          this.loading = false;
        });
    },

    search() {
      let MaterialId = this.query.obj;
      if (MaterialId != null && MaterialId != "") {
        let searchInfo = {
          MaterialId: MaterialId,
          PageSize: 20,
          PageIndex: 1,
          TotalCount: 0,
          StartNumber: 0,
          EndNumber: 0
        };
        this.loading = true;
        this.loadingText = "加载中...";
        new MyApis.MaterialsApi()
          .GetItemById(searchInfo)
          .then(r => {
            r = r.data.Data;
            //console.log(r);
            this.ruleForm = r;
            this.loading = false;
          })
          .catch(e => {
            console.error(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
            this.loading = false;
          });
      }
    },
    //返回按钮
    onBack() {
      this.$router.go(-1); //返回上一层
    },
    //重置
    resetForm() {
      this.ruleForm = {StockNum:1};
      this.query.obj = null;
    },
    //保存
    submitForm(formName) {
      //this.ruleForm.BuyDate=this.stringToDate(this.ruleForm.BuyDate);
      //this.ruleForm.ExpireDate=this.stringToDate(this.ruleForm.ExpireDate);
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.save();
        } else {
          console.error("error submit!!");
          return false;
        }
      });
    },

    save() {
      this.ruleForm.StockNum = parseInt(this.ruleForm.StockNum);
      this.ruleForm.IsInOut = true;
      this.ruleForm.Recipients = "admin";
      if (this.user.Departments != null && this.user.Departments.length > 0) {
        var dept = this.user.Departments[0];
        this.ruleForm.OrgId = dept.OrgId; //this.user.OrgId;
      }

      if (this.ruleForm.BuyDate > this.ruleForm.ExpireDate) {
        this.errmsg("有效期不能小于购入日期！");
        return;
      }
      if (this.query.obj == null || this.query.obj == "") {
        this.loading = true;
        this.loadingText = "保存中...";
        new MyApis.MaterialsApi()
          .AddItem(this.ruleForm)
          .then(r => {
            r = r.data.Data;
            this.$message({
              type: "success",
              message: r ? "保存成功！" : "保存失败！"
            });
            this.logInfo.ActionName = "应急物资添加";
            this.logInfo.LogMessage = r ? "应急物资添加成功" : "应急物资添加失败";
            this.logInfo.ModuleName = "应急系统";
            this.logInfo.PageName = "应急物资详情页面";
            this.addOperationLog();
            this.$router.go(-1); //返回上一层
            this.loading = false;
          })
          .catch(e => {
            console.error(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
            this.loading = false;
          });
      } else {
        this.loading = true;
        this.loadingText = "保存中...";
        new MyApis.MaterialsApi()
          .UpdateItem(this.ruleForm)
          .then(r => {
            r = r.data.Data;
            this.$message({
              type: "success",
              message: r ? "保存成功！" : "保存失败！"
            });
            this.logInfo.ActionName = "应急物资修改";
            this.logInfo.LogMessage = r ? "应急物资修改成功" : "应急物资修改失败";
            this.logInfo.ModuleName = "应急系统";
            this.logInfo.PageName = "应急物资详情页面";
            this.addOperationLog();
            this.$router.go(-1); //返回上一层
            this.loading = false;
          })
          .catch(e => {
            console.error(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
            this.loading = false;
          });
      }
    },
    changeWarehouse(val) {
      const AddressList = this.warehouselist.filter(
        item => item.WarehouseId == val
      );
      if(AddressList.length>0){
        this.ruleForm.Address = AddressList[0].Address
      }
    }
  }
};
</script>